<template>
  <div class="row">
    <div
      :class="{
        col: true,
        'sidebar-page': true,
        open: isOpenSidebarPage,
        'hide-filter': hideFilter,
      }"
    >
      <a class="page-heading" @click="onHeadingClick">
        <span>{{ filter.title }}</span>
        <span
          v-if="filter.info"
          class="info-icon ms-2 lh-1"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          data-bs-trigger="click hover focus"
          :title="filter.info"
          @click.stop="filterTooltipClick"
        >
          <icon-questionmark />
        </span>
        <span v-if="count > 0" class="active-filter-count d-md-none">
          {{ count }}
        </span>
        <icon-chevron-right class="orange d-md-none" />
        <icon-chevron-up class="md-chevron" />
        <icon-chevron-down class="md-chevron" />
      </a>
      <div class="page-content">
        <ToggleRefinement
          v-if="filter.type === 'toggle'"
          :attribute="filter.attribute"
          :label="filter.label"
          :notify-count="setCount"
          @filter-update="$emit('filter-update', $event)"
        />

        <RefinementList
          v-if="filter.type === 'list'"
          :attribute="filter.attribute"
          :operator="filter.operator"
          :get-label="filter.getLabel"
          :get-icon="filter.getIcon"
          :notify-count="setCount"
          :limit="filter.limit"
          :show-more-button-text="filter.showMoreButton"
          :show-less-button-text="filter.showLessButton"
          :searchable="filter.searchable"
          :searchable-placeholder="filter.searchablePlaceholder"
          :transform-items="filter.transformItems"
          @filter-update="$emit('filter-update', $event)"
        />

        <PriceRangeFilter
          v-if="filter.type === 'price'"
          :attribute="filter.attribute"
          :currency-symbol="$store.state.currencySymbol"
          :notify-count="setCount"
          @filter-update="
            (value, count) => {
              setCount(count);
              $emit('filter-update', value);
            }
          "
        />

        <SortByFilter
          v-if="filter.type === 'sort'"
          @filter-update="$emit('filter-update')"
        />

        <a
          v-if="filter.link && filter.link.text && filter.link.url"
          class="text-danger"
          :href="filter.link.url"
        >
          {{ filter.link.text }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import RefinementList from './filters/RefinementList.vue';
import ToggleRefinement from './filters/ToggleRefinement.vue';
import PriceRangeFilter from './filters/PriceRangeFilter.vue';
import SortByFilter from './filters/SortByFilter.vue';

import IconQuestionmark from '../../../../templates/icons/questionmark.svg';
import IconChevronRight from '../../../../templates/icons/chevron-right.svg';
import IconChevronUp from '../../../../templates/icons/chevron-up.svg';
import IconChevronDown from '../../../../templates/icons/chevron-down.svg';

export default {
  components: {
    RefinementList,
    ToggleRefinement,
    PriceRangeFilter,
    SortByFilter,
    IconQuestionmark,
    IconChevronRight,
    IconChevronUp,
    IconChevronDown,
  },
  props: {
    filter: {
      type: Object,
      default() {
        return {
          type: '',
          title: '',
          info: '',
          attribute: '',
          label: '',
          link: {
            text: null,
            url: null,
          },
          limit: false,
          showMoreButton: '',
          showLessButton: '',
          searchable: false,
          searchablePlaceholder: '',
          getLabel: null,
          getIcon: null,
        };
      },
    },
  },
  data() {
    return {
      count: 0,
      isOpenSidebarPage: false,
      hideFilter: false,
    };
  },
  methods: {
    onHeadingClick() {
      const breakpoint = window.getResponsiveBreakpoint();
      if (['xs', 'sm'].includes(breakpoint)) {
        // Mobile
        this.$emit('openSidebarPage');
        this.isOpenSidebarPage = true;
        this.hideTooltips();
      } else {
        // Desktop
        this.hideFilter = !this.hideFilter;
      }
    },
    closeSidebarPage() {
      this.isOpenSidebarPage = false;
    },
    filterTooltipClick(event) {
      this.hideTooltips(event.delegateTarget);
    },
    hideTooltips(exceptEl) {
      document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
        if (!exceptEl || el != exceptEl) {
          window.bootstrap.Tooltip.getInstance(el).hide();
        }
      });
    },
    setCount(n) {
      this.count = n;
    },
  },
};
</script>
